"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgMicrophoneSlash32 = function SvgMicrophoneSlash32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.707 1.707A1 1 0 0030.293.293L23 7.586V5.75c0-1.007-.372-2.445-1.46-3.642C20.423.881 18.639 0 16 0c-2.639 0-4.423.88-5.54 2.108C9.372 3.305 9 4.743 9 5.75v9.5c0 1.171.509 2.96 2.095 4.24l-1.332 1.333C7.686 18.873 7 15.98 7 14a1 1 0 10-2 0c0 2.29.768 5.786 3.348 8.238L.293 30.293a1 1 0 101.414 1.414l30-30zM12.522 18.064l6.564-6.564H18.4a1 1 0 110-2H21V7.278h-2.6a1 1 0 110-2h2.557a3.678 3.678 0 00-.897-1.824C19.377 2.703 18.162 2 16 2s-3.377.703-4.06 1.454a3.678 3.678 0 00-.897 1.824H13.6a1 1 0 110 2H11V9.5h2.6a1 1 0 110 2H11v2.222h2.6a1 1 0 110 2h-2.557a3.68 3.68 0 001.479 2.342z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M22.117 15.02a1 1 0 01.786 1.175c-.356 1.785-1.775 4.108-5.241 4.676a1 1 0 11-.324-1.973c2.517-.413 3.384-1.992 3.603-3.093a1 1 0 011.176-.786z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M26 13a1 1 0 011 1c0 1.925-.537 4.647-2.192 6.917-1.557 2.136-4.056 3.8-7.808 4.05V31a1 1 0 11-2 0v-6.033a13.128 13.128 0 01-1.47-.18 1 1 0 11.357-1.967c.64.116 1.342.18 2.113.18 3.686 0 5.884-1.467 7.192-3.261C24.537 17.894 25 15.617 25 14a1 1 0 011-1z",
    fill: "currentColor"
  }));
};

SvgMicrophoneSlash32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgMicrophoneSlash32;
exports.default = _default;